module.exports = __webpack_public_path__ + "static/media/roboto1.7370c367.woff2";